/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { patientsControllerCreate } from '../fn/patients/patients-controller-create';
import { PatientsControllerCreate$Params } from '../fn/patients/patients-controller-create';
import { patientsControllerDelete } from '../fn/patients/patients-controller-delete';
import { PatientsControllerDelete$Params } from '../fn/patients/patients-controller-delete';
import { patientsControllerFilter } from '../fn/patients/patients-controller-filter';
import { PatientsControllerFilter$Params } from '../fn/patients/patients-controller-filter';
import { patientsControllerFindOne } from '../fn/patients/patients-controller-find-one';
import { PatientsControllerFindOne$Params } from '../fn/patients/patients-controller-find-one';
import { patientsControllerReactivate } from '../fn/patients/patients-controller-reactivate';
import { PatientsControllerReactivate$Params } from '../fn/patients/patients-controller-reactivate';
import { patientsControllerUpdate } from '../fn/patients/patients-controller-update';
import { PatientsControllerUpdate$Params } from '../fn/patients/patients-controller-update';
import { patientsControllerUpdateAssignment } from '../fn/patients/patients-controller-update-assignment';
import { PatientsControllerUpdateAssignment$Params } from '../fn/patients/patients-controller-update-assignment';
import { ResponsePatientDto } from '../models/response-patient-dto';

@Injectable({ providedIn: 'root' })
export class PatientsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `patientsControllerCreate()` */
  static readonly PatientsControllerCreatePath = '/thalea-patients/patients';

  /**
   * Create a patient.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientsControllerCreate$Response(params: PatientsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePatientDto>> {
    return patientsControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a patient.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientsControllerCreate(params: PatientsControllerCreate$Params, context?: HttpContext): Observable<ResponsePatientDto> {
    return this.patientsControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePatientDto>): ResponsePatientDto => r.body)
    );
  }

  /** Path part for operation `patientsControllerFindOne()` */
  static readonly PatientsControllerFindOnePath = '/thalea-patients/patients/{tenant}/{id}';

  /**
   * Find a patient by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientsControllerFindOne$Response(params: PatientsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePatientDto>> {
    return patientsControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Find a patient by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientsControllerFindOne(params: PatientsControllerFindOne$Params, context?: HttpContext): Observable<ResponsePatientDto> {
    return this.patientsControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePatientDto>): ResponsePatientDto => r.body)
    );
  }

  /** Path part for operation `patientsControllerUpdate()` */
  static readonly PatientsControllerUpdatePath = '/thalea-patients/patients/{tenant}/{id}';

  /**
   * Update a patient.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientsControllerUpdate$Response(params: PatientsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePatientDto>> {
    return patientsControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a patient.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientsControllerUpdate(params: PatientsControllerUpdate$Params, context?: HttpContext): Observable<ResponsePatientDto> {
    return this.patientsControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePatientDto>): ResponsePatientDto => r.body)
    );
  }

  /** Path part for operation `patientsControllerDelete()` */
  static readonly PatientsControllerDeletePath = '/thalea-patients/patients/{tenant}/{id}';

  /**
   * Delete a patient.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientsControllerDelete$Response(params: PatientsControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patientsControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a patient.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientsControllerDelete(params: PatientsControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.patientsControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patientsControllerReactivate()` */
  static readonly PatientsControllerReactivatePath = '/thalea-patients/patients/{tenant}/{id}/reactivate';

  /**
   * Reactivate a patient.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientsControllerReactivate()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientsControllerReactivate$Response(params: PatientsControllerReactivate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patientsControllerReactivate(this.http, this.rootUrl, params, context);
  }

  /**
   * Reactivate a patient.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientsControllerReactivate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientsControllerReactivate(params: PatientsControllerReactivate$Params, context?: HttpContext): Observable<void> {
    return this.patientsControllerReactivate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patientsControllerFilter()` */
  static readonly PatientsControllerFilterPath = '/thalea-patients/patients/filter';

  /**
   * Filter patients based on query parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientsControllerFilter()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientsControllerFilter$Response(params: PatientsControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponsePatientDto>>> {
    return patientsControllerFilter(this.http, this.rootUrl, params, context);
  }

  /**
   * Filter patients based on query parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientsControllerFilter$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientsControllerFilter(params: PatientsControllerFilter$Params, context?: HttpContext): Observable<Array<ResponsePatientDto>> {
    return this.patientsControllerFilter$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponsePatientDto>>): Array<ResponsePatientDto> => r.body)
    );
  }

  /** Path part for operation `patientsControllerUpdateAssignment()` */
  static readonly PatientsControllerUpdateAssignmentPath = '/thalea-patients/patients/{tenant}/{id}/assignment';

  /**
   * Assign psychologist or clinic to patient.
   *
   * Updates psychoId or clinicId. Provide only one field per request.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientsControllerUpdateAssignment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientsControllerUpdateAssignment$Response(params: PatientsControllerUpdateAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePatientDto>> {
    return patientsControllerUpdateAssignment(this.http, this.rootUrl, params, context);
  }

  /**
   * Assign psychologist or clinic to patient.
   *
   * Updates psychoId or clinicId. Provide only one field per request.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientsControllerUpdateAssignment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientsControllerUpdateAssignment(params: PatientsControllerUpdateAssignment$Params, context?: HttpContext): Observable<ResponsePatientDto> {
    return this.patientsControllerUpdateAssignment$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePatientDto>): ResponsePatientDto => r.body)
    );
  }

}
